import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/item/$uuid')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/verify/$uuid',
      params: { uuid: params.uuid },
      search: search as Record<string, string>,
      statusCode: 301,
    });
  },
});
